import type { WidgetType } from '@dreamstack/feature-components/src/Accordion/AccordionStyledComponents'
import { SimpleAccordionEntry } from '@dreamstack/feature-components/src/Accordion/SimpleAccordionEntry'
import { BlockAccordionEntry } from '@dreamstack/payload/src/payload-types'
import type { FunctionComponent } from 'react'
import { ChildrenBlockSpacingContainer } from '../contentful/ChildrenBlockSpacingContainer'
import { ContentfulBlocks } from '../contentful/ContentfulBlocks'

export const AccordionEntry: FunctionComponent<
  React.PropsWithChildren<{
    block: NonNullable<BlockAccordionEntry>[number]
    customProps?: {
      processAccordionEntryClick?: (integer: number, boolean: boolean) => void
      index: number
      useAqua: boolean
      smallSize: boolean
      widgetType: WidgetType
    }
  }>
> = ({ block, customProps }) => {
  return (
    <SimpleAccordionEntry
      clickHandler={customProps?.processAccordionEntryClick}
      index={customProps?.index}
      title={block?.title ?? ''}
      titleWhenExpanded={block?.titleWhenExpanded || ''}
      useAqua={customProps?.useAqua}
      smallSize={customProps?.smallSize}
      widgetType={customProps?.widgetType}
    >
      <ChildrenBlockSpacingContainer>
        <ContentfulBlocks blocks={block?.blocks ?? []} />
      </ChildrenBlockSpacingContainer>
    </SimpleAccordionEntry>
  )
}
